var React = require('react');

function At (props) {
    return React.createElement("svg",props,React.createElement("g",{"fillRule":"evenodd"},[React.createElement("path",{"fill":"#fff","d":"M640 480H0V0h640z","key":0}),React.createElement("path",{"fill":"#df0000","d":"M640 480H0V320h640zm0-319.9H0V.1h640z","key":1})]));
}

At.defaultProps = {"viewBox":"0 0 640 480"};

module.exports = At;

At.default = At;
